import React from 'react';
import PropTypes from 'prop-types';
import css from './Sections.module.css';
import { Icons, SecondaryButton } from '../../../components';
import classNames from 'classnames';
import sellerFee from '../../../assets/fast-secure.png';
import routeConfiguration from '../../../routing/routeConfiguration';
import { createResourceLocatorString } from '../../../util/routes';
import { intlShape } from '../../../util/reactIntl';

function SectionPayment({ intl, history }) {
  return (
    <div className={css.paymentContainer}>
      <div className={css.fixedWidthContainer}>
        <h1>{intl.formatMessage({ id: 'HowItWorksPage.SectionPayment.title' })}</h1>
        <div className={css.featuresContent}>
          <h2>{intl.formatMessage({ id: 'HowItWorksPage.SectionPayment.subtitle' })}</h2>
        </div>
        <div className={css.protectionTypeSec}>
          <div className={css.protectionTypeBlock}>
            <h2>{intl.formatMessage({ id: 'HowItWorksPage.SectionPayment.whatYoureProtectedFrom.title' })}</h2>
            <div className={css.protectionContent}>
              <div className={css.protectionType}>
                {intl.formatMessage({ id: 'HowItWorksPage.SectionPayment.whatYoureProtectedFrom.item1' })}
              </div>
              <div className={css.protectionType}>
                {intl.formatMessage({ id: 'HowItWorksPage.SectionPayment.whatYoureProtectedFrom.item2' })}
              </div>
              <div className={css.protectionType}>
                {intl.formatMessage({ id: 'HowItWorksPage.SectionPayment.whatYoureProtectedFrom.item3' })}
              </div>
              <div className={css.protectionType}>
                {intl.formatMessage({ id: 'HowItWorksPage.SectionPayment.whatYoureProtectedFrom.item4' })}
              </div>
              <div className={css.protectionType}>
                {intl.formatMessage({ id: 'HowItWorksPage.SectionPayment.whatYoureProtectedFrom.item5' })}
              </div>
            </div>
          </div>
          <div className={css.protectionTypeBlock}>
            <h2>{intl.formatMessage({ id: 'HowItWorksPage.SectionPayment.yourProtectionInAction.title' })}</h2>
            <div className={css.protectionContent}>
              <div className={css.protectionType}>{intl.formatMessage({ id: 'HowItWorksPage.SectionPayment.yourProtectionInAction.step1' })}</div>
              <Icons name="downPointer" />
              <div className={css.protectionType}>{intl.formatMessage({ id: 'HowItWorksPage.SectionPayment.yourProtectionInAction.step2' })}</div>
              <Icons name="downPointer" />
              <div className={css.protectionType}>{intl.formatMessage({ id: 'HowItWorksPage.SectionPayment.yourProtectionInAction.step3' })}</div>
              <Icons name="downPointer" />
              <div className={css.protectionType}>{intl.formatMessage({ id: 'HowItWorksPage.SectionPayment.yourProtectionInAction.step4' })}</div>
              <Icons name="downPointer" />
              <div className={css.protectionType}>{intl.formatMessage({ id: 'HowItWorksPage.SectionPayment.yourProtectionInAction.step5' })}</div>
              <Icons name="downPointer" />
              <div className={css.protectionType}>{intl.formatMessage({ id: 'HowItWorksPage.SectionPayment.yourProtectionInAction.step6' })}</div>
            </div>
          </div>
        </div>
        <div className={css.sellerFeeSec}>
          <div className={css.sellerFeeInfo}>
            <h2>{intl.formatMessage({ id: 'HowItWorksPage.SectionPayment.processTitle' })}</h2>
            <p>{intl.formatMessage({ id: 'HowItWorksPage.SectionPayment.processDescription' })}</p>
            <SecondaryButton 
              onClick={() => history.push(createResourceLocatorString('SearchPage', routeConfiguration(), {}, {}))}
            >
              {intl.formatMessage({ id: 'HowItWorksPage.SectionPayment.startBrowsing' })}
            </SecondaryButton>
          </div>
          <div className={css.sellerFeeImg}>
            <img src={sellerFee} alt="sellerFee" />
          </div>
        </div>
      </div>
    </div>
  );
}

SectionPayment.propTypes = {
  intl: intlShape.isRequired,
};

export default SectionPayment;